<template>
    <div>
        <section class="business-bg">
            <div class="container shape-container pt-md-5">
                <div class="pt-md-5">
                    <div class="col-lg-8 pt-5">
                        <div class="row pt-5">
                            <h3 class="display-3 mt-5">DO YOU OWN A BUSINESS?
                            <span class="">SELL DIRECT DATA AND AIRTIME TO YOUR CUSTOMERS</span>
                            </h3>
                            <p class="lead text-dark mt-0">With easy transfers, fast and reliable top up; recharge your <br>staff, reward your customers
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

         <section class="section px-lg-0 px-4">
            <div class="container">
                <div class="row row-grid align-items-center pb-md-5">
                    <div class="col-md-6 order-md-2" data-aos="fade-left" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                        <div class="pl-md-5">
                            <div class="mb-4">
                                <img src="img/icons/common/enterprise.svg" class="img-fluid">
                            </div>
                            <p>The business is the point of service, its where we deliver and offer value. And for value to be added, there 
                                must be a system which has to have a human factor involved which is the people. The people are the business, 
                                that's why TopupBox has created a system for business to reward it's staff, send them data, recharge their lines 
                                and be the support they can for them to keep the business running
                            </p>
                             <p>TopupBox has created a mechanism that automates this system which makes it seamless and direct
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 order-md-1">
                        <img src="img/theme/people-shaking.png" class="img-fluid rounded shadow-lg">
                    </div>
                </div>
            </div>
        </section>

        <section class="pb-5 px-lg-0 px-4">
            <div class="container">
                <div class="text-center justify-content-center">
                    <div class="col-lg-12">
                        <h2 class="display-3 text-default">Cases</h2>
                        <p class="lead mb-5">Need to use TopupBox as a business? Here's how</p>
                    </div>
                </div>
                <div class="row justify-content-center mb-4">
                    <div class="col-lg-12">
                        <div class="row row-grid" data-aos="fade-up" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                            <div class="col-lg-6">
                                <card class="border-0" shadow body-classes="py-5">
                                    <div class="row">
                                        <div class="col-3 d-flex justify-content-center align-items-center">
                                            <div class="mb-4">
                                                <img src="img/icons/common/good.svg" class="img-fluid">
                                            </div>
                                        </div>
                                        <div class="col-9">
                                            <h6 class="text-primary text-uppercase display-4">Airtime</h6>
                                            <p class="description mt-3">
                                                With TopupBox, you can add your staff as beneficiaries and broadcast bulk airtime/data at once to all staff at fast and easy rates
                                            </p>
                                        </div>
                                    </div>
                                </card>
                            </div>
                            <div class="col-lg-6">
                                <card class="border-0" shadow body-classes="py-5">
                                    <div class="row">
                                        <div class="col-3 d-flex justify-content-center align-items-center">
                                            <div class="mb-4">
                                                <img src="img/icons/common/good.svg" class="img-fluid">
                                            </div>
                                        </div>
                                        <div class="col-9">
                                            <h6 class="text-primary text-uppercase display-4">Data</h6>
                                            <p class="description mt-3">
                                                For those working from home, be their data support. And at the office, keep the internet on and let your systems keep running
                                            </p>
                                        </div>
                                    </div>
                                </card>
                            </div>
                        </div>
                        <div class="row row-grid" data-aos="fade-up" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                            <div class="col-lg-6">
                                <card class="border-0" shadow body-classes="py-5">
                                    <div class="row">
                                        <div class="col-3 d-flex justify-content-center align-items-center">
                                            <div class="mb-4">
                                                <img src="img/icons/common/good.svg" class="img-fluid">
                                            </div>
                                        </div>
                                        <div class="col-9">
                                            <h6 class="text-primary text-uppercase display-4">Gifts for your clients</h6>
                                            <p class="description mt-3">
                                                Reward your customers for their patronage and loyalty. 
                                                Easy and quick from your dashboard on our website, you can get that done and keep your reward system intact
                                            </p>
                                        </div>
                                    </div>
                                </card>
                            </div>
                            <div class="col-lg-6">
                                <card class="border-0" shadow body-classes="py-5">
                                    <div class="row">
                                        <div class="col-3 d-flex justify-content-center align-items-center">
                                            <div class="mb-4">
                                                <img src="img/icons/common/good.svg" class="img-fluid">
                                            </div>
                                        </div>
                                        <div class="col-9">
                                            <h6 class="text-primary text-uppercase display-4">Budget</h6>
                                            <p class="description mt-3">
                                                Budget for your airtime and data needs by funding your wallet straight on TopupBox with ease. 
                                                Seamless communication can now with be done with airtime or data.
                                            </p>
                                        </div>
                                    </div>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid" data-aos="fade-up" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                            <div class="col-lg-6">
                                <card class="border-0" shadow body-classes="py-5">
                                    <div class="row">
                                        <div class="col-3 d-flex justify-content-center align-items-center">
                                            <div class="mb-4">
                                                <img src="img/icons/common/forward.svg" class="img-fluid">
                                            </div>
                                        </div>
                                        <div class="col-9">
                                            <h6 class="text-primary text-uppercase display-4">Enterprise</h6>
                                            <p class="description mt-3">
                                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima dicta doloremque eum placeat quisquam, 
                                                quibusdam aut rerum omnis eaque voluptatum sunt sapiente, 
                                                beatae porro tenetur excepturi, minus sint ut dolorum.
                                            </p>
                                        </div>
                                    </div>
                                </card>
                            </div>
                            <div class="col-lg-6">
                                <card class="border-0" shadow body-classes="py-5">
                                    <div class="row">
                                        <div class="col-3 d-flex justify-content-center align-items-center">
                                            <div class="mb-4">
                                                <img src="img/icons/common/forward.svg" class="img-fluid">
                                            </div>
                                        </div>
                                        <div class="col-9">
                                            <h6 class="text-primary text-uppercase display-4">Enterprise</h6>
                                            <p class="description mt-3">
                                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima dicta doloremque eum placeat quisquam, 
                                                quibusdam aut rerum omnis eaque voluptatum sunt sapiente, 
                                                beatae porro tenetur excepturi, minus sint ut dolorum.
                                            </p>
                                        </div>
                                    </div>
                                </card>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </section>
       
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>